<template>
  <template v-for="(fieldData, fieldKey, index) in structure" v-bind:key="fieldKey">
    <template v-if="isSection(fieldData)">
      <KeepAlive>
      <accordion-section :identifier="fieldKey" :mtdt="fieldData" :index="index + 1">
        <template v-slot:content>
          <recursive-component :identifier="fieldKey" :structure="fieldData.Tree"
            :level="level + 1"></recursive-component>
        </template>
      </accordion-section>
    </KeepAlive>

    </template>
    <template v-else-if="isTable(fieldData)">
      <KeepAlive>
        <Table :mtdt="fetchMetaData(asString(fieldKey))" :identifier="fieldKey" :key="fieldKey" :level="level">
          <template v-if="fieldData.Template">
            <v-runtime-template :template="fieldData.Template"></v-runtime-template>
          </template>
        </Table>
      </KeepAlive>
    </template>
    <template v-else-if="isOverlay(fieldData)">

    </template>
    <template v-else>
      <KeepAlive>
        <component :key="fieldKey" :identifier="fieldKey" :is="getComponentType(fieldData)"
          :mtdt="fetchMetaData(asString(fieldKey))" :level="level">
          <template v-if="fieldData.Template">
            <v-runtime-template :template="fieldData.Template"></v-runtime-template>
          </template>
        </component>
      </KeepAlive>
    </template>
  </template>
</template>
<script lang="ts" src="@/library/builder/RecursiveComponent.ts"></script>
